






import Vue from 'vue';

export default Vue.extend({
  name: `ProfileAvatar`,
  computed: {
    avatarImage(): string {
      return `--background-image-link:url(${this.imageLink}&h=260&fit=crop&crop=faces);`;
    },
  },
  props: {
    imageLink: {
      required: true,
      type: String,
    },
  },
});
